module.exports = {
      id: "5a43a204cc61b8db83893e3277767d80equipment-window-bars.svg-usage",
      viewBox: "0 0 100 100",
      url: __webpack_public_path__ + "sprite.ba3d6e28.svg#5a43a204cc61b8db83893e3277767d80equipment-window-bars.svg",
      toString: function () {
        return this.url;
      }
    }